import { setSessionItem, getSessionItem } from 'lib/util/localStorage';

function initializePrerollHistory() {
    if (!getSessionItem('playedItems')) {
        setSessionItem('playedItems', []);
    }
}

/**
 * getPrerollSetting - Returns a boolean flag used to set `opts.preroll` in player options.
 * If `savePrerollHistory` is defined along with the `contentId` parameter,
 * this function will initialize played items session storage to keep track of already played streams.
 * If a stream has been played (stored in storage), it will return false to avoid preroll.
 *
 * @param {object} prerollConfig = {} - Object containing contentType specific preroll properties such
 * as `enablePreroll` and `savePrerollHistory`.
 * @param {string} contentId - contentId of the given stream to be played
 *
 * @return {boolean}
 */
export default (prerollConfig = {}, contentId) => {
    const { savePrerollHistory = false, enablePreroll = false } = prerollConfig;

    if (savePrerollHistory && typeof contentId === 'string' && contentId.trim() !== '') {
        initializePrerollHistory();
        const playedItemsInSession = getSessionItem('playedItems');

        if (playedItemsInSession.indexOf(contentId) === -1) {
            setSessionItem('playedItems', [...playedItemsInSession, ...[contentId]]);
            return true;
        }

        return false;
    }

    return enablePreroll;
};



// WEBPACK FOOTER //
// ./app/webapp/player/util/getPrerollSetting.js